var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.972 3.25H10.91v1.31h2.063V3.25ZM9.66 2v2.857H5.095v2.604H3.667v1.25h1.428V22h13.691V8.71h1.548V7.46h-1.548V4.857h-4.564V2H9.66Zm7.877 5.46V6.108H6.346v1.354h11.19ZM6.346 8.71v12.04h11.19V8.71H6.346Zm3.363 10.681V9.826h1.25v9.565h-1.25Zm3.333-9.565v9.565h1.25V9.826h-1.25Z",
    fill: "currentColor"
  })));
};
export default SvgTrash;